// Bright colors for each category - used for tags and icons
// NO YELLOW/AMBER/GOLD - replaced with other bright colors
export const categoryColors = {
  workplace: {
    bg: 'bg-blue-500',
    text: 'text-white',
    border: 'border-blue-500',
    iconBg: 'bg-blue-500/10',
    iconText: 'text-blue-500',
    hex: '#3B82F6'
  },
  social: {
    bg: 'bg-emerald-500',
    text: 'text-white',
    border: 'border-emerald-500',
    iconBg: 'bg-emerald-500/10',
    iconText: 'text-emerald-500',
    hex: '#10B981'
  },
  idioms: {
    bg: 'bg-purple-500',
    text: 'text-white',
    border: 'border-purple-500',
    iconBg: 'bg-purple-500/10',
    iconText: 'text-purple-500',
    hex: '#8B5CF6'
  },
  sarcasm: {
    bg: 'bg-sky-500',
    text: 'text-white',
    border: 'border-sky-500',
    iconBg: 'bg-sky-500/10',
    iconText: 'text-sky-500',
    hex: '#0EA5E9'
  },
  texting: {
    bg: 'bg-cyan-500',
    text: 'text-white',
    border: 'border-cyan-500',
    iconBg: 'bg-cyan-500/10',
    iconText: 'text-cyan-500',
    hex: '#06B6D4'
  },
  dating: {
    bg: 'bg-pink-500',
    text: 'text-white',
    border: 'border-pink-500',
    iconBg: 'bg-pink-500/10',
    iconText: 'text-pink-500',
    hex: '#EC4899'
  },
  family: {
    bg: 'bg-orange-500',
    text: 'text-white',
    border: 'border-orange-500',
    iconBg: 'bg-orange-500/10',
    iconText: 'text-orange-500',
    hex: '#F97316'
  },
  services: {
    bg: 'bg-teal-500',
    text: 'text-white',
    border: 'border-teal-500',
    iconBg: 'bg-teal-500/10',
    iconText: 'text-teal-500',
    hex: '#14B8A6'
  },
  genz: {
    bg: 'bg-fuchsia-500',
    text: 'text-white',
    border: 'border-fuchsia-500',
    iconBg: 'bg-fuchsia-500/10',
    iconText: 'text-fuchsia-500',
    hex: '#D946EF'
  },
  millennial: {
    bg: 'bg-rose-500',
    text: 'text-white',
    border: 'border-rose-500',
    iconBg: 'bg-rose-500/10',
    iconText: 'text-rose-500',
    hex: '#F43F5E'
  },
  genx: {
    bg: 'bg-indigo-500',
    text: 'text-white',
    border: 'border-indigo-500',
    iconBg: 'bg-indigo-500/10',
    iconText: 'text-indigo-500',
    hex: '#6366F1'
  },
  british: {
    bg: 'bg-red-500',
    text: 'text-white',
    border: 'border-red-500',
    iconBg: 'bg-red-500/10',
    iconText: 'text-red-500',
    hex: '#EF4444'
  },
  aussie: {
    bg: 'bg-lime-500',
    text: 'text-white',
    border: 'border-lime-500',
    iconBg: 'bg-lime-500/10',
    iconText: 'text-lime-500',
    hex: '#84CC16'
  },
  southern: {
    bg: 'bg-green-500',
    text: 'text-white',
    border: 'border-green-500',
    iconBg: 'bg-green-500/10',
    iconText: 'text-green-500',
    hex: '#22C55E'
  },
  urban: {
    bg: 'bg-violet-500',
    text: 'text-white',
    border: 'border-violet-500',
    iconBg: 'bg-violet-500/10',
    iconText: 'text-violet-500',
    hex: '#8B5CF6'
  }
};

export const getCategoryColor = (categoryId) => {
  return categoryColors[categoryId] || categoryColors.workplace;
};
